/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Day_Free_DetailInputs */

const en_us2_today_day_free_detail = /** @type {(inputs: Today_Day_Free_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Train on whichever day suits you`)
};

const pt_br2_today_day_free_detail = /** @type {(inputs: Today_Day_Free_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treine no dia que for melhor para você`)
};

const es_419_today_day_free_detail = /** @type {(inputs: Today_Day_Free_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrena el día que mejor te quede`)
};

const pt_pt2_today_day_free_detail = /** @type {(inputs: Today_Day_Free_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treina no dia que te der mais jeito`)
};

const fr_fr2_today_day_free_detail = /** @type {(inputs: Today_Day_Free_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entraîne-toi le jour qui te convient`)
};

const de_de2_today_day_free_detail = /** @type {(inputs: Today_Day_Free_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainiere an dem Tag, der dir passt`)
};

const it_it2_today_day_free_detail = /** @type {(inputs: Today_Day_Free_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenati nel giorno che preferisci`)
};

/**
* | output |
* | --- |
* | "Train on whichever day suits you" |
*
* @param {Today_Day_Free_DetailInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_free_detail = /** @type {((inputs?: Today_Day_Free_DetailInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_Free_DetailInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_free_detail(inputs)
	if (locale === "es-419") return es_419_today_day_free_detail(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_free_detail(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_free_detail(inputs)
	if (locale === "de-DE") return de_de2_today_day_free_detail(inputs)
	if (locale === "it-IT") return it_it2_today_day_free_detail(inputs)
	return en_us2_today_day_free_detail(inputs)
});
export { today_day_free_detail as "today.day_free_detail" }